export const photoUploadingRoomAndAlbumSelector = ({ gallery: { photoUploadingRoomAndAlbum: value } }: any) => value;
